<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="100px">
      <el-form-item label="店铺全称" prop="storeFullName" v-if="!rowData">
        <el-select v-model="addForm.storeFullName" filterable placeholder="请选择">
          <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeFullName" :value="item.storeFullName"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺全称" prop="storeFullName" v-else>
        <span>{{ addForm.storeFullName }}</span>
      </el-form-item>
      <el-form-item label="平台客服ID" prop="platCustomerServiceId" v-if="!rowData">
        <el-input v-model.trim="addForm.platCustomerServiceId" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="平台客服ID" prop="platCustomerServiceId" v-else>
        <el-tooltip
          class="item"
          effect="dark"
          :content="addForm.platCustomerServiceId"
          placement="top-start"
          v-if="addForm.platCustomerServiceId && addForm.platCustomerServiceId.length >= 30"
        >
          <div class="textTips">{{ addForm.platCustomerServiceId || "" }}</div>
        </el-tooltip>
        <div class="textTips" v-else>{{ addForm.platCustomerServiceId || "" }}</div>
      </el-form-item>
      <el-form-item label="用户" prop="userId">
        <el-select
          v-model="userId"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="handleUserInfoChange"
        >
          <el-option v-for="item in userList" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="用户" v-else>
        {{ addForm.userName + "-" + addForm.workNo }}
      </el-form-item> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="责任部门" prop="responsibleDepartment">
            <el-select v-model="addForm.responsibleDepartment" filterable placeholder="请选择" @change="responsibleDepartmentChange">
              <el-option v-for="item in responsibleDepartmentList.filter((v) => v != '(空白)')" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客服等级" prop="customerServiceLevel">
            <el-select v-model="addForm.customerServiceLevel" filterable clearable placeholder="请选择">
              <el-option v-for="item in customerServiceLevelList.filter((v) => v != '(空白)')" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入职时间" prop="employDate">
            <el-date-picker v-model="addForm.employDate" type="date" value-format="yyyyMMdd" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位" prop="workJobs">
            <el-input v-model.trim="addForm.workJobs" maxlength="100" :disabled="addForm.responsibleDepartment != '兼职'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model.trim="addForm.companyName" maxlength="100" :disabled="addForm.responsibleDepartment != '兼职'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    customerServiceLevelList: {
      type: Array,
      default: [],
    },
    responsibleDepartmentList: {
      type: Array,
      default: [],
    },
    storeList: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {},
      userId: "",
      userList: [],
      all: false,
      rules: {
        storeFullName: [{ required: true, message: "不能为空", trigger: "change" }],
        platCustomerServiceId: [{ required: true, message: "不能为空", trigger: "blur" }],
        userId: [{ required: true, message: "不能为空", trigger: "blur" }],
        responsibleDepartment: [{ required: true, message: "不能为空", trigger: "change" }],
        employDate: [{ required: true, message: "不能为空", trigger: "change" }],
        customerServiceLevel: [{ required: false, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData ? "编辑" : "新增";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      this.addForm = addForm;
      this.userId = addForm.userId;
      this.remoteMethod(addForm.userName);
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          ...this.addForm,
          storeCode: !this.rowData ? this.storeList.find((v) => v.storeFullName == this.addForm.storeFullName).storeCode : this.rowData.storeCode,
        };
        this.$q.qualityTestingManage
          .customerServiceSaveOrUpdate({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },

    responsibleDepartmentChange(val) {
      if (val == "全职") {
        this.rules.customerServiceLevel[0].required = true;
      } else {
        this.rules.customerServiceLevel[0].required = false;
        this.$refs.addForm.clearValidate("customerServiceLevel");
      }
    },
    remoteMethod(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
          this.loading = false;
        }
      });
    },
    handleUserInfoChange(data) {
      const activeObj = this.userList.find((v) => v.userId === this.userId);
      this.$set(this.addForm, "userId", activeObj.userId);
      this.$set(this.addForm, "workNo", activeObj.workNo);
      this.$set(this.addForm, "userName", activeObj.userName);
      this.$set(this.addForm, "workJobs", activeObj.workJobs);
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 220px !important
>>> .el-input
  width 220px !important
>>> .el-form-item__content .textTips {
  cursor: pointer
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}
</style>
